import styled, { css } from "styled-components/macro";
import { COLORES } from "../../constants";

export const Tr = styled.form`
  display: table-row;
  height: 1.75rem;
  background-color: ${(props) =>
    props.highlighted ? COLORES.HIGHLIGHTED : COLORES.BACKGROUND};

  :hover {
    background-color: ${COLORES.HIGHLIGHTED};
  }

  color: ${(props) => props.deleted && COLORES.DELETED};
`;

export const Td = styled.div`
  display: table-cell;
  vertical-align: middle;
  border: thin solid ${COLORES.LIGHT_BORDER};
  ${(props) =>
    props.type !== "enum" &&
    props.type !== "relate" &&
    css`      
      text-overflow: ellipsis;
      white-space: nowrap;
    `}

  button {
    font-weight: bold;
    border: none;
    border-radius: 0.2rem;
    margin-left: 0 0.2rem;
    color: ${COLORES.BUTTON_TEXT_DEFAULT};
    background-color: ${COLORES.BUTTON_BACKGROUND_DEFAULT};
    line-height: 1.35rem;
  }
`;

export const Checkbox = styled.div`
  display: table-cell;
  vertical-align: middle;
  border: thin solid ${COLORES.LIGHT_BORDER};
  text-align: center;
`;

export const InputCheckbox = styled.input`
  vertical-align: middle;
`;
